import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Top-level project fields of the block project-employer-communication ("Kommunikation mit
 * Auftraggeber") with their payload type (`preparePayloadForGraphQL`). Must match
 * `ProjectEmployerCommunicationInput` in the API schema; `createPayload` reuses the types.
 */
export const PROJECT_EMPLOYER_COMMUNICATION_FIELD_TYPES = {
  askEmployerCategoryState: 'string',
  askEmployerNote: 'string',
  answerFromEmployerNote: 'string',
};

export const PROJECT_EMPLOYER_COMMUNICATION_INPUT_FIELDS = Object.keys(
  PROJECT_EMPLOYER_COMMUNICATION_FIELD_TYPES
);

/** `ProjectEmployerCommunicationInput` from the block object (or the unsaved project). */
export const toProjectEmployerCommunicationInput = (project) =>
  preparePayloadForGraphQL(project, PROJECT_EMPLOYER_COMMUNICATION_FIELD_TYPES);
